import { render, staticRenderFns } from "./PosOptions.vue?vue&type=template&id=4eda928f&"
import script from "./PosOptions.vue?vue&type=script&lang=js&"
export * from "./PosOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports